import { LegalClientHeadEntity } from 'api/types/entity';
import { formatToDate } from 'helpers';
import { TFunc } from 'libs/i18n';
import {
  parseAddressValue,
  parseTaxResidencesValue,
  parsePepConnectionInitialValue,
  parseResidentialAddressValue,
  parseIdentityDocumentWithFilesInitialValue,
  parseCitizenshipsValue,
  parseHeadPositionInitialValue,
} from 'modules/client/common/helpers';

import { LegalClientHeadFormType } from '../../forms/legalClientHeadForm';

export const getLegalClientHeadInitialValue = (
  client: LegalClientHeadEntity,
  t: TFunc
): LegalClientHeadFormType => ({
  contacts: {
    email: client.email,
  },
  reasonChange: { reason: '' },

  personalData: {
    firstName: client.firstName,
    lastName: client.lastName,
    middleName: client.middleName ?? '',
    dateOfBirth: client.dateOfBirth,
  },

  citizenships: parseCitizenshipsValue(client.citizenships),

  taxResidences: parseTaxResidencesValue(client.taxResidences),

  registrationAddress: parseAddressValue(client.registrationAddress),
  residentialAddress: parseResidentialAddressValue(client.residentialAddress),

  pepConnection: parsePepConnectionInitialValue(client.pepConnection, t),

  position: parseHeadPositionInitialValue(client, t),

  activity: {
    id: client.id,
    createdAt: formatToDate(client.createdAt),
  },

  identityDocument: parseIdentityDocumentWithFilesInitialValue(
    t,
    client.identityDocument
  ),
  additionalDocumentsFiles: client.additionalInformationFiles,

  placeOfBirth: {
    country: client.placeOfBirth?.country ?? null,
    locality: client.placeOfBirth?.locality ?? '',
  },
});
